import superMeta from '../_CATEGORY/metaCategoryNode.mjs'

export default {
    ...superMeta,
    name: '相关系统',
    type: 'BRF_SYS',
}
